if (document.querySelector(".footer-mobile__common [data-open-search-popup]")) {
  document
    .querySelector(".footer-mobile__common [data-open-search-popup]")
    .addEventListener("click", (e) => {
      document.querySelector('[name="q"]')?.click();
    });
}

document
  .querySelectorAll(
    ".sf-media-nav .nav-swiper-container .sf-prod-media.media-image,.nav-swiper-container-mobile .sf-prod-media.media-image"
  )
  .forEach((thumb) => {
    thumb.addEventListener("click", (e) => {
      if (e.target.closest("[data-media-id]") && mainProduct) {
        const variant = mainProduct.variants.find(
          (variant) =>
            variant.featured_media &&
            +variant.featured_media.id ===
              +e.target.closest("[data-media-id]").getAttribute("data-media-id")
        );
        if (variant) {
          document
            .querySelector(`.prod__option [data-value="${variant.title}"]`)
            ?.click();
        }
      }
    });
  });

if (location.hash == "#contact-form-ask-product") {
  document.querySelector(".form-ask__success-block").style.display = "block";
}

//Deactivate image hover for Boost Filter:
if (typeof boostPFSThemeConfig != "undefined")
  boostPFSThemeConfig.custom.active_image_swap = false;

if (location.hash != "#contact-form-ask-product") {
  const urlParams = new URLSearchParams(window.location.search);
  if (
    document.querySelector(".questionSection") &&
    urlParams.get("contact_posted") === "true"
  ) {
    const thankYouText = document.createElement("div");
    thankYouText.className = "thankYouForQuestion";
    thankYouText.innerText =
      "Thanks for asking. We'll get back to you as soon as possible.";
    document.querySelector(".questionSection").innerHTML = "";
    document.querySelector(".questionSection").appendChild(thankYouText);
    thankYouText.style.maxHeight = "200px";
    thankYouText.style.padding = "7px";
  }
}

// //Deactivate image hover for Boost Filter:
// if (typeof boostPFSThemeConfig != "undefined")
//   boostPFSThemeConfig.custom.active_image_swap = false;

// const urlParams = new URLSearchParams(window.location.search);
// if (
//   document.querySelector(".questionSection") &&
//   urlParams.get("contact_posted") === "true"
// ) {
//   const thankYouText = document.createElement("div");
//   thankYouText.className = "thankYouForQuestion";
//   thankYouText.innerText =
//     "Thanks for asking. We'll get back to you as soon as possible.";
//   document.querySelector(".questionSection").innerHTML = "";
//   document.querySelector(".questionSection").appendChild(thankYouText);
//   thankYouText.style.maxHeight = "200px";
//   thankYouText.style.padding = "7px";
// }

document
  .querySelectorAll(".customSortOption:not(.customDropdown)")
  .forEach((option) => {
    option.addEventListener("click", (e) => {
      e.preventDefault();
      const sortOptionSelected = document.querySelector(
        `.boost-pfs-filter-filter-dropdown [data-sort="${option.getAttribute(
          "data-value"
        )}"]`
      );
      if (sortOptionSelected) {
        option.parentElement
          .querySelector(".selected")
          .classList.remove("selected");
        document
          .querySelectorAll(
            ".customSortOption.customDropdown .customSortOptionDropdownValue.selected"
          )
          .forEach((opt) => {
            opt.classList.remove("selected");
          });
        document
          .querySelector(".customSortOption.customDropdown")
          .classList.remove("selected");
        document.querySelector(".currentSelectedDropdownValue").innerText =
          "Price";
        option.classList.add("selected");
        sortOptionSelected.click();
      }
    });
  });

document
  .querySelectorAll(
    ".customSortOption.customDropdown .customSortOptionDropdownValue"
  )
  .forEach((option) => {
    option.addEventListener("click", (e) => {
      e.preventDefault();
      const sortOptionSelected = document.querySelector(
        `.boost-pfs-filter-filter-dropdown [data-sort="${option.getAttribute(
          "data-value"
        )}"]`
      );
      if (sortOptionSelected) {
        option.parentElement
          .querySelector(".selected")
          ?.classList.remove("selected");
        document
          .querySelectorAll(".customSortOption.selected")
          .forEach((opt) => {
            opt.classList.remove("selected");
          });
        option.classList.add("selected");
        document
          .querySelector(".customSortOption.customDropdown")
          .classList.add("selected");
        sortOptionSelected.click();
        document.querySelector(".currentSelectedDropdownValue").innerText =
          option.innerText;
      }
      document.querySelector(
        ".customSortOption.customDropdown"
      ).style.pointerEvents = "none";
      setInterval(() => {
        document.querySelector(
          ".customSortOption.customDropdown"
        ).style.pointerEvents = "visible";
      }, 100);
    });
  });

/*** Custom Testimonials setup ***/

const setUpTestimonialSwiper = (testimonialSection) => {
  var mySwiper = new MinimogLibs.Swiper(
    testimonialSection.querySelector(".swiper-container"),
    {
      spaceBetween: 1,
      slidesPerView: 5,
      centeredSlides: true,
      roundLengths: true,
      loop: true,
      loopAdditionalSlides: 30,
      navigation: {
        nextEl: testimonialSection.querySelector(".swiper-button-next"),
        prevEl: testimonialSection.querySelector(".swiper-button-prev"),
      },
    }
  );
  mySwiper.on("slideChange", function (swiper) {
    const currentActiveSlideBlockId =
      swiper.slides[swiper.activeIndex].getAttribute("data-block-id");
    const currentActiveText = testimonialSection.querySelector(
      ".aboutTestimonial.currentActive"
    );
    const toBeActiveText = testimonialSection.querySelector(
      `.aboutTestimonial[data-block-id="${currentActiveSlideBlockId}"]`
    );
    currentActiveText.classList.remove("currentActive");
    /*setTimeout(()=>{
        currentActiveText && currentActiveText.classList.add('hidden')
         toBeActiveText.classList.remove('hidden')
        setTimeout(()=>{
            toBeActiveText.classList.add('currentActive')        
        }, 200)
    }, 500)*/
    currentActiveText.classList.add("hidden");
    toBeActiveText.classList.remove("hidden");
    toBeActiveText.classList.add("currentActive");
  });
};

const checkMinimogLibsAvailable = setInterval(() => {
  if (MinimogLibs.Swiper) {
    clearInterval(checkMinimogLibsAvailable);

    //Set up featuredCollection Slider:
    const resetHomeFeaturedSwiper = (
      homePageFeaturedCollectionSwiper,
      collectionSwiper
    ) => {
      homePageFeaturedCollectionSwiper.swiper.destroy();
      const paginationIcon = `<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>`;
      let init = false;
      function swiperCard() {
        if (window.innerWidth > 768) {
          if (!init) {
            init = true;
            swiper = new MinimogLibs.Swiper(homePageFeaturedCollectionSwiper, {
              slidesPerView: 4.75,
              loop: true,
              container: this.container,
              showNavigation: true,
              showPagination: true,
              pagination: {
                el: collectionSwiper.querySelector(".swiper-pagination"),
                clickable: true,
                bulletClass: "sf__dot",
                bulletActiveClass: "sf__dot-active",
                renderBullet: function (index, className) {
                  return (
                    '<span class="' +
                    className +
                    '">' +
                    paginationIcon +
                    "</span>"
                  );
                },
              },
              navigation: {
                nextEl: collectionSwiper.querySelector(
                  ".collection-list__controls .sf-slider__controls-next"
                ),
                prevEl: collectionSwiper.querySelector(
                  ".collection-list__controls .sf-slider__controls-prev"
                ),
              },
            });
          }
        } else if (init) {
          swiper.destroy();
          init = false;
        }
      }
      swiperCard();
      window.addEventListener("resize", swiperCard);
    };

    //Set up home page products slider:
    const resetUpHomeProductsSection = (
      homeProductsSwiper,
      customProductSection
    ) => {
      /*
      homeProductsSwiper.swiper.destroy();
      */
      const slides = customProductSection.querySelectorAll(".swiper-slide");
      const paginationIcon = `<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>`;

      new MinimogLibs.Swiper(homeProductsSwiper, {
        slidesPerView: slides.length < 4 ? slides.length : 4,
        initialSlide: 2,
        loop: false,
        mousewheel: true,
        //showPagination: slides.length < 4 ? false: true,
        breakpoints: {
          280: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          768: {
            slidesPerView: 2.75,
            slidesPerGroup: 1,
          },
          992: {
            slidesPerView: 3.75,
            slidesPerGroup: 1,
          },
          1028: {
            slidesPerView: 4,
            slidesPerGroup: 1,
          },
        },
        showPagination: true,
        pagination: {
          el: customProductSection
            .closest(".custom_product_section")
            .querySelector(".swiper-pagination"),
          clickable: true,
          bulletClass: "sf__dot",
          bulletActiveClass: "sf__dot-active",
          renderBullet: function (index, className) {
            return (
              '<span class="' + className + '">' + paginationIcon + "</span>"
            );
          },
        },
        navigation: {
          nextEl: customProductSection
            .closest(".custom_product_section")
            .querySelector(".sf-slider__controls-next"),
          prevEl: customProductSection
            .closest(".custom_product_section")
            .querySelector(".sf-slider__controls-prev"),
        },
      });
    };

    //Set up custom services swiper:
    const setUpCustomServicesSection = (customServicesSection) => {
      const paginationIcon = `<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>`;
      let init = false;
      function swiperCard() {
        if (window.innerWidth > 768) {
          if (!init) {
            init = true;
            swiper = new MinimogLibs.Swiper(customServicesSection, {
              slidesPerView: 4.75,
              spaceBetween: 25,
              loop: true,
              showNavigation: true,
              showPagination: true,
              pagination: {
                el: customServicesSection
                  .closest(".custom_services_main")
                  .querySelector(".swiper-pagination"),
                clickable: true,
                bulletClass: "sf__dot",
                bulletActiveClass: "sf__dot-active",
                renderBullet: function (index, className) {
                  return (
                    '<span class="' +
                    className +
                    '">' +
                    paginationIcon +
                    "</span>"
                  );
                },
              },
              navigation: {
                nextEl: customServicesSection
                  .closest(".custom_services_main")
                  .querySelector(".sf-slider__controls-next"),
                prevEl: customServicesSection
                  .closest(".custom_services_main")
                  .querySelector(".sf-slider__controls-prev"),
              },
            });
          }
        } else if (init) {
          swiper.destroy();
          init = false;
        }
      }
      swiperCard();
      window.addEventListener("resize", swiperCard);
    };

    //Set up related products slider:
    const resetUpRelatedProductsSection = (
      relatedProductsSwiper,
      relatedProductsSection
    ) => {
      const paginationIcon = `<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>`;

      new MinimogLibs.Swiper(relatedProductsSwiper, {
        slidesPerView: 4,
        initialSlide: 2,
        loop: false,
        mousewheel: true,
        showPagination: true,
        breakpoints: {
          280: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          768: {
            slidesPerView: 2.75,
            slidesPerGroup: 1,
          },
          992: {
            slidesPerView: 3.75,
            slidesPerGroup: 1,
          },
          1028: {
            slidesPerView: 4,
            slidesPerGroup: 1,
          },
        },
        pagination: {
          el: relatedProductsSection.querySelector(".swiper-pagination"),
          clickable: true,
          bulletClass: "sf__dot",
          bulletActiveClass: "sf__dot-active",
          renderBullet: function (index, className) {
            return (
              '<span class="' + className + '">' + paginationIcon + "</span>"
            );
          },
        },
      });
    };

    //Set up Testimonials Slider

    if (document.querySelectorAll(".custom_testimonial_main").length) {
      try {
        document
          .querySelectorAll(".custom_testimonial_main")
          .forEach((testimonialSection) => {
            setUpTestimonialSwiper(testimonialSection);
          });
      } catch (error) {
        console.log(error);
      }
    }

    if (document.querySelectorAll(".homePageFeaturedCollections").length) {
      try {
        document
          .querySelectorAll(".homePageFeaturedCollections")
          .forEach((collectionSwiper) => {
            if (collectionSwiper.querySelector(".sf__ms-wrapper")) {
              let homePageFeaturedCollectionSwiper =
                collectionSwiper.querySelector(".sf__ms-wrapper");
              if (homePageFeaturedCollectionSwiper.swiper) {
                resetHomeFeaturedSwiper(
                  homePageFeaturedCollectionSwiper,
                  collectionSwiper
                );
              } else {
                const awaitHomePageFeaturedSwiper = setInterval(() => {
                  homePageFeaturedCollectionSwiper =
                    collectionSwiper.querySelector(".sf__ms-wrapper");
                  if (homePageFeaturedCollectionSwiper.swiper) {
                    clearInterval(awaitHomePageFeaturedSwiper);
                    resetHomeFeaturedSwiper(
                      homePageFeaturedCollectionSwiper,
                      collectionSwiper
                    );
                  }
                }, 500);
              }
            }
          });
      } catch (error) {
        console.log(error);
      }
    }

    if (document.querySelectorAll(".custom_product_section").length) {
      try {
        document
          .querySelectorAll(".custom_product_section")
          .forEach((customProductSection) => {
            if (customProductSection.querySelector(".sf__ms-wrapper")) {
              let homeProductsSwiper =
                customProductSection.querySelector(".sf__ms-wrapper");
              /*
              if (customProductSection.swiper) {
              */
              resetUpHomeProductsSection(
                homeProductsSwiper,
                customProductSection
              );
              /*} else {
                const awaitHomePageProductsSwiper = setInterval(() => {
                  homeProductsSwiper =
                    customProductSection.querySelector(".sf__ms-wrapper");
                  if (homeProductsSwiper.swiper) {
                    clearInterval(awaitHomePageProductsSwiper);
                    resetUpHomeProductsSection(
                      homeProductsSwiper,
                      customProductSection
                    );
                  }
                }, 500);
              }*/
            }
          });
      } catch (error) {
        console.log(error);
      }
    }

    if (document.querySelectorAll(".custom_services").length) {
      try {
        document
          .querySelectorAll(".custom_services")
          .forEach((customServicesSection) => {
            setUpCustomServicesSection(customServicesSection);
          });
      } catch (error) {
        console.log(error);
      }
    }

    /* if (document.querySelectorAll(".custom_product_recommendations").length) {
      try {
        document
          .querySelectorAll(".custom_product_recommendations")
          .forEach((relatedProductsSection) => {
            if (relatedProductsSection.querySelector(".sf-grid")) {
              let relatedProductsSwiper =
                relatedProductsSection.querySelector(".sf-grid");
              debugger;
              resetUpRelatedProductsSection(
                relatedProductsSwiper,
                relatedProductsSection
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    }*/
  }
}, 500);

/*** Custom Testimonials setup End***/

/*** Custom Collection Page FAQ Setup ***/
if (document.querySelector(".customFAQContainer")) {
  try {
    const createFAQAccordions = (questions) => {
      let newQuestionsContainer = document.createElement("div");
      newQuestionsContainer.className = "customFAQAccordions";
      newQuestionsContainer.innerHTML = `<div class='container'>
                    <div class="section__header text- ">
                        <h2 class="section__heading">FAQ</h2>
                    </div>
                    <div class="prod__accordion">
                    </div>
                    </div>`;
      questions.forEach((q, index) => {
        if (
          q.nextElementSibling &&
          q.nextElementSibling.tagName != "H2" &&
          q.nextElementSibling.tagName != "H3"
        ) {
          let collapsibleItem = `<div class="sf__accordion-item" data-index="${index}" style="--content-max-height:0px;"> 
                      <div class="sf__accordion-button lg:text-[18px] pb-2.5 pr-4 border-b border-color-border">`;
          collapsibleItem += q.innerText + "</div>";
          collapsibleItem += `<div class="sf__accordion-content text-color-secondary overflow-hidden" style="opacity: 1;">
                        <div class="pt-5 pb-10 prose">`;
          let nextElement = q.nextElementSibling;
          while (
            nextElement != "n/a" &&
            nextElement.tagName != "H2" &&
            nextElement.tagName != "H3"
          ) {
            collapsibleItem += `<p>${nextElement.innerHTML}</p>`;
            const tempElement = nextElement;
            nextElement = nextElement.nextElementSibling ?? "n/a";
            tempElement.remove();
          }

          collapsibleItem += `</div>
                    </div>
                    </div>`;
          newQuestionsContainer.querySelector(".prod__accordion").innerHTML +=
            collapsibleItem;
          q.remove();
        }
      });
      document
        .querySelector(".inner_lower_main")
        .parentElement.classList.add("sf-collapsible");
      document
        .querySelector(".inner_lower_main")
        .parentElement.classList.add("collectionFAQ");
      document
        .querySelector(".inner_lower_main")
        .parentElement.appendChild(newQuestionsContainer);
      //document.querySelector(".inner_lower_main").remove();
    };
    faqQuestions = document.querySelectorAll(".inner_lower_main h2");
    if (faqQuestions.length) {
      createFAQAccordions(faqQuestions);
    } else if (document.querySelectorAll(".inner_lower_main h3").length) {
      //In case optizen makes the headers h3s instead of h2s
      faqQuestions = document.querySelectorAll(".inner_lower_main h3");
      createFAQAccordions(faqQuestions);
    }
  } catch (error) {
    console.log(error);
  }
}

document
  .querySelectorAll(".customFAQAccordions:not(.initializedCustomAccordion)")
  .forEach((customFAQAccordions) => {
    customFAQAccordions
      .querySelectorAll(".sf__accordion-item")
      .forEach((accordion) => {
        accordion.isOpen = false;
        accordion.addEventListener("click", (e) => {
          if (!accordion.isOpen) {
            accordion.classList.add("open");
            const totalHeight = accordion.querySelector(
              ".sf__accordion-content .prose"
            ).scrollHeight;
            accordion.style.setProperty(
              "--content-max-height",
              totalHeight + "px"
            );
          } else {
            accordion.classList.remove("open");
            accordion.style.setProperty("--content-max-height", 0 + "px");
          }
          accordion.isOpen = !accordion.isOpen;
        });
      });
    customFAQAccordions.classList.add("initializedCustomAccordion");
  });

/*** Custom Collection Page FAQ Setup End***/

/*** Move EasySpec specs to mobile accordion ***/
if (
  document.querySelector("#details .specificationsContainerCustom") &&
  document.querySelector(
    ".sf__accordion-item.productDetailsSpecifications .sf__accordion-content .prose"
  )
) {
  const specificationsData = document.querySelector(
    "#details .specificationsContainerCustom .specData"
  );
  document.querySelector(
    ".sf__accordion-item.productDetailsSpecifications .sf__accordion-content .prose"
  ).innerHTML = specificationsData.innerHTML;
}
/*** Move EasySpec specs to mobile accordion End***/

const availabilityModal = document.querySelector(
  ".contactForAvailabilityModal"
);
const closeAvailabilityModal = () => {
  availabilityModal
    .querySelector(".form-ask__wrapper")
    .classList.remove("hidden");
  setTimeout(() => {
    availabilityModal.classList.remove("opacity-100");
    availabilityModal.classList.add("hiddenModal");
    setTimeout(() => {
      availabilityModal.style.display = "none";
      availabilityModal.querySelector('[name="contact[subject]"]').value = "";
    }, 500);
  }, 500);
};

const openAvailabilityModal = (subject, itemName, itemURL) => {
  if (!availabilityModal.querySelector('[name="contact[subject]"]')) {
    availabilityModal.querySelector(".sf-modal__content-inner").innerHTML = `
          <div class="form-ask__wrapper">
          <form method="post" action="/contact#contact-form-ask" id="contact-form-ask" accept-charset="UTF-8" class="contact-form">
            <input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="contact[product]" value="">
            <input type="hidden" name="contact[product url]" value="">
            <div class="p-8 text-center">
              <h3 class="text-4xl mb-6">Ask a Question</h3>
              <input type="text" class="form-control" name="contact[name]" required="" placeholder="Your Name*">
              <input type="text" class="form-control" name="contact[subject]" required="" placeholder="Subject">
              <input type="text" class="form-control" name="contact[phone]" placeholder="Your Phone Number">
              <input type="email" class="form-control" name="contact[email]" required="" autocorrect="off" placeholder="Your Email*">
              <textarea class="form-control" name="contact[question]" rows="4" required="" placeholder="Your Message*"></textarea>
              <p class="italic text-left text-color-subtext mb-3">* Required fields</p>
              <button type="submit" class="sf__btn sf__btn-primary">Submit Now</button>
            </div>
            <div class="form-ask__success fixed bottom-1/2 md:bottom-24 left-1/2 -translate-x-1/2 z-50 shadow-theme md:shadow-none w-[80vw] md:w-auto" data-message="Thanks for asking. We'll get back to you as soon as possible."></div>
          </form>
          </div>
        `;
  }
  availabilityModal.querySelector('[name="contact[subject]"]').value = subject;
  availabilityModal.querySelector('[name="contact[product]"]').value = itemName;
  availabilityModal.querySelector('[name="contact[product url]"]').value =
    itemURL;
  availabilityModal.style.display = "flex";
  setTimeout(() => {
    availabilityModal.classList.remove("hiddenModal");
    availabilityModal.classList.add("opacity-100");
    availabilityModal
      .querySelector(".form-ask__wrapper")
      .classList.remove("hidden");
  }, 100);
};

document
  .querySelectorAll(".contactForAvailabilityModal .sf-modal__close")
  .forEach((closeBtn) => {
    closeBtn.addEventListener("click", (e) => {
      availabilityModal
        .querySelector(".form-ask__wrapper")
        .classList.remove("hidden");
      setTimeout(() => {
        availabilityModal.classList.remove("opacity-100");
        availabilityModal.classList.add("hiddenModal");
        setTimeout(() => {
          availabilityModal.style.display = "none";
        }, 500);
      }, 500);
    });
  });

document
  .querySelectorAll(
    "div:not(.template-collection) .sf__pcard .contactForPriceModalTrigger,div:not(.template-collection) .sf__pcard .contact-availability"
  )
  .forEach((contactBtn) => {
    contactBtn.addEventListener("click", (e) => {
      const itemName = contactBtn
        .closest(".sf__pcard")
        .querySelector(".sf__pcard-name").innerText;
      const itemURL = contactBtn
        .closest(".sf__pcard-content")
        .querySelector(".sf__pcard-name").href;
      const context = contactBtn.classList.contains(
        "contactForPriceModalTrigger"
      )
        ? "Price inquiry for "
        : "Availability inquiry for ";
      const subject = context + itemName;
      openAvailabilityModal(subject, itemName, itemURL);
      e.preventDefault();
    });
  });

document
  .querySelectorAll(
    ".main-product__block .contactForPriceModalTrigger, .main-product__block .contact-availability, .contactFormTrigger.mobilePDPButton"
  )
  .forEach((contactMainBtn) => {
    contactMainBtn.addEventListener("click", (e) => {
      const itemName = contactMainBtn
        .closest(".main-product__blocks")
        .querySelector(".prod__title h1").innerText;
      const itemURL = window.location;
      const context = contactMainBtn.classList.contains(
        "contactForPriceModalTrigger"
      )
        ? "Price inquiry for "
        : "Availability inquiry for ";
      const subject = context + itemName;
      openAvailabilityModal(subject, itemName, itemURL);
      e.preventDefault();
    });
  });

availabilityModal.addEventListener("click", (e) => {
  if (
    !e.target.classList.contains(".sf-modal__content") &&
    !e.target.closest(".sf-modal__content")
  ) {
    closeAvailabilityModal();
  }
});
document
  .querySelectorAll(".contactForAvailabilityModal .sf-modal__close")
  .forEach((closeBtn) => {
    closeBtn.addEventListener("click", (e) => {
      closeAvailabilityModal();
    });
  });

//Utility Date format function
const formatDate = (date) => {
  const yyyy = date.getUTCFullYear();
  let mm = date.getMonth() + 1;
  let dd = date.getUTCDate();

  mm < 10 ? (mm = "0" + mm) : "";
  dd < 10 ? (dd = "0" + dd) : "";
  return dd + "/" + mm + "/" + yyyy;
};

//Variant Change Handler (For Contact For Availability)
try {
  //This function handles showing specials text for products on special sale:
  const handleVariantSale = (variantId) => {
    if (window.mainProduct.tags.includes("Custom Sale")) {
      //Product has at least one variant on sale:
      const selectedVariant = window.mainProduct.variants.find(
        (v) => String(v.id) === String(variantId)
      );
      debugger;

      if (
        selectedVariant &&
        +selectedVariant.metafields.custom.original_price > 0
      ) {
        //Varaint is currently on sale:
        const saleDescription = mainProduct.metafields.custom.sale_description;
        const specialTo = mainProduct.metafields.custom.special_to;
        const dateText = `Offer valid until ${formatDate(new Date(specialTo))}`;
        //Client no longer wants original price to be shown
        /* const originalPrice =
          `$` +
          (+selectedVariant.metafields.custom.original_price.amount).toFixed(2);
          */
        document.querySelector(".specialsTextHolder").innerHTML = `
            <div class="specialGoing">
                ${
                  saleDescription
                    ? "<p class='saleDescription'>" + saleDescription + "</p>"
                    : ""
                }
                ${dateText ? "<p class='dateText'>" + dateText + "</p>" : ""}
            </div>
        `;
        /*
        if (!document.querySelector(".product-prices .originalPrice")) {
          const originalPriceParagraph = document.createElement("p");
          originalPriceParagraph.innerText = originalPrice;
          originalPriceParagraph.classList.add("originalPrice");
          document
            .querySelector(".product-prices")
            .appendChild(originalPriceParagraph);
        } else {
          document.querySelector(".product-prices .originalPrice").innerText =
            originalPrice;
        }*/
      } else {
        document.querySelector(".specialsTextHolder").innerHTML = ``;
        /*
        document.querySelector(".product-prices .originalPrice")?.remove();
        */
      }
    }
  };
  const handleVariantChangeAll = (newVariantId) => {
    const selectedVariant = window.mainProduct.variants.find(
      (v) => +v.id === +newVariantId
    );
    if (selectedVariant) {
      if (
        selectedVariant.metafields &&
        selectedVariant.metafields.custom &&
        selectedVariant.metafields.custom.deactivate_product
      ) {
        window.location.href = "/404";
      }

      if (!selectedVariant.available) {
        document.querySelectorAll(".customButton").forEach((i) => i.remove());
        const mainButton = document.querySelector(".mainProductBtn");
        const stickyMainButton = document.querySelector(
          ".prod__sticky-atc .mainProductBtn"
        );
        const contactBtns = [];

        for (let i = 0; i < 2; i++) {
          const contactForAvailabilityBtn = document.createElement("button");
          contactForAvailabilityBtn.className =
            "sf__btn flex-grow shrink not-change relative sf__btn-primary sold-out contact-availability customButton";
          contactForAvailabilityBtn.innerHTML = `<span class="not-change atc-text">
                               <span class="contactText">Contact</span> <span class="contactRestText">For Availability</span>  
                            </span>`;
          contactForAvailabilityBtn.addEventListener("click", (e) => {
            e.preventDefault();
            const itemName = selectedVariant.name;
            const itemURL = window.location;
            const context = "Availability inquiry for ";
            const subject = context + itemName;
            openAvailabilityModal(subject, itemName, itemURL);
          });
          contactBtns.push(contactForAvailabilityBtn);
        }
        mainButton.parentElement.insertBefore(contactBtns[0], mainButton);
        stickyMainButton.parentElement.insertBefore(
          contactBtns[1],
          stickyMainButton
        );
      } else {
        document.querySelectorAll(".customButton").forEach((i) => i.remove());
      }
    }
  };

  const handleVariantChangeSticky = (newVariantId) => {
    const selectedVariant = window.mainProduct.variants.find(
      (v) => +v.id === +newVariantId
    );
    if (selectedVariant) {
      if (
        !selectedVariant.available ||
        (selectedVariant.metafields &&
          selectedVariant.metafields.custom &&
          selectedVariant.metafields.custom.deactivate_product)
      ) {
        document
          .querySelectorAll("#sticky-atc-form .customButton")
          .forEach((i) => i.remove());
        const stickyMainButton = document.querySelector(
          ".prod__sticky-atc .mainProductBtn"
        );

        const contactForAvailabilityBtn = document.createElement("button");
        contactForAvailabilityBtn.className =
          "sf__btn flex-grow shrink not-change relative sf__btn-primary sold-out contact-availability customButton";
        contactForAvailabilityBtn.innerHTML = `<span class="not-change atc-text">
                               <span class="contactText">Contact</span> <span class="contactRestText">For Availability</span>  
                            </span>`;
        contactForAvailabilityBtn.addEventListener("click", (e) => {
          e.preventDefault();
          const itemName = selectedVariant.name;
          const itemURL = window.mainProduct.url;
          const context = "Availability inquiry for ";
          const subject = context + itemName;
          openAvailabilityModal(subject, itemName, itemURL);
        });
        stickyMainButton.parentElement.insertBefore(
          contactForAvailabilityBtn,
          stickyMainButton
        );
      } else {
        document
          .querySelectorAll("#sticky-atc-form .customButton")
          .forEach((i) => i.remove());
      }
    }
  };

  const setVariantChangeListener = async () => {
    if (
      document.querySelector(".sf-prod-template") &&
      document.querySelector(".product-form input[name=id]")
    ) {
      const variantValueInput = document.querySelector(
        ".product-form input[name=id]"
      );
      const stickyVariantInput = document.querySelector(
        "#sticky-atc-form input[name=id]"
      );

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "value"
          ) {
            if (
              mutation.target.parentElement.getAttribute("id") ===
              "sticky-atc-form"
            )
              handleVariantChangeSticky(stickyVariantInput.value);
            else {
              handleVariantChangeAll(variantValueInput.value);
              handleVariantSale(variantValueInput.value);
            }
          }
        });
      });

      observer.observe(variantValueInput, {
        attributes: true,
        attributeFilter: ["value"],
      });
      observer.observe(stickyVariantInput, {
        attributes: true,
        attributeFilter: ["value", "sd"],
      });
      //Initial Button Handle:
      handleVariantChangeAll(variantValueInput.value);
    }
  };

  setVariantChangeListener();
} catch (e) {
  console.log(e);
  alert("Something went wrong");
}

/****** Move Some of the collection text to FAQ ******/
if (
  document.querySelector(".textToBeUnderCollection") &&
  document.querySelector(".textToBeUnderCollection").innerText.length
) {
  const moveTextBelow = () => {
    const textToMove = document
      .querySelector(".textToBeUnderCollection")
      .cloneNode(true);
    textToMove.classList.add("container-fluid");
    document
      .querySelector(".customFAQAccordions")
      .insertBefore(
        textToMove,
        document.querySelector(".customFAQAccordions .container")
      );
  };
  moveTextBelow();
}
/****** Move Some of the collection text to FAQ ******/

/***** This script assimilates all brands into one main node (had to be done due to Shopiify's limit of 50 blocks per section) ***/
const allBrandsContainers = document.querySelectorAll(
  ".brands-list__container"
);
if (allBrandsContainers.length > 1) {
  const mainBrandsContainer = allBrandsContainers[0];

  allBrandsContainers.forEach((container, index) => {
    if (index > 0) {
      const elementsToMove = [];
      container.querySelectorAll(".brandsSubsection").forEach((subsection) => {
        const startsWith = subsection.getAttribute("data-starts-with");
        const existingSubsection = mainBrandsContainer.querySelector(
          `.brandsSubsection[data-starts-with="${startsWith}"]`
        );

        if (existingSubsection) {
          subsection.querySelectorAll(".brand_blocks > li").forEach((brand) => {
            elementsToMove.push({ brand, startsWith });
          });
        } else {
          elementsToMove.push({ subsection });
        }
      });
      container.remove();
      const fragment = document.createDocumentFragment();
      elementsToMove.forEach((element) => {
        if (element.brand) {
          const targetSubsection = mainBrandsContainer.querySelector(
            `.brandsSubsection[data-starts-with="${element.startsWith}"] .brand_blocks`
          );
          fragment.appendChild(element.brand);
          targetSubsection.appendChild(fragment);
        } else {
          fragment.appendChild(element.subsection);
        }
      });

      mainBrandsContainer.appendChild(fragment);
    }
  });
}

/***** End ***/

class brandsNavigationObject {
  constructor() {
    this.lettersArray = [];
    this.searchItemsArray = [];
    this.selectedLettersArray = [];

    this.allBrandTitles = document.querySelectorAll(".brand_title");
    this.letttersFilterContainer = document.querySelector(
      ".brandsNavigation .brandLetters"
    );
    this.searchBar = document.querySelector(
      ".brandsSearchBar .brandsSearchInput"
    );
    this.suggestionsContainer = document.querySelector(
      ".brandsSearchBar .suggestions"
    );

    this.init();
  }

  getLetters() {
    document.querySelectorAll("[data-starts-with]").forEach((letterArray) => {
      this.lettersArray.push(letterArray.getAttribute("data-starts-with"));
    });
  }

  getAllBrands() {
    this.allBrandTitles.forEach((title) =>
      this.searchItemsArray.push({
        title: title.innerHTML,
        link: title.closest("li").querySelector(".brand_image a").href,
      })
    );
  }

  setUpLettersButton() {
    this.lettersArray.forEach((letter) => {
      const letterBtn = document.createElement("button");
      letterBtn.className = "brandLettersBtn";
      letterBtn.innerText = letter;
      letterBtn.addEventListener("click", (e) => {
        const isSelected = this.selectedLettersArray.find(
          (item) => item === letter
        );
        if (typeof isSelected != "undefined") {
          letterBtn.classList.remove("filteredBrand");
          /*this.selectedLettersArray = this.selectedLettersArray.filter(
            (item) => item != letter
          );*/
          this.selectedLettersArray = [];
        } else {
          const currentSelectedBrand =
            letterBtn.parentElement.querySelector(".filteredBrand");
          if (currentSelectedBrand)
            currentSelectedBrand.classList.remove("filteredBrand");
          letterBtn.classList.add("filteredBrand");
          //this.selectedLettersArray.push(letter);
          this.selectedLettersArray = [letter];
        }
        //Set query params:
        const url = new URL(window.location.href);
        if (this.selectedLettersArray.length)
          url.searchParams.set("selectedLetters", this.selectedLettersArray);
        else url.searchParams.delete("selectedLetters");
        window.history.pushState({}, "", url);
        this.triggerFilter();
      });
      this.letttersFilterContainer.appendChild(letterBtn);
    });
  }

  setUpSearchBar() {
    this.searchBar.addEventListener("input", (e) => {
      this.handleSearch(e);
    });
    this.searchBar.addEventListener("blur", (e) => {
      setTimeout(() => {
        e.target.classList.add("isBlurred");
      }, 150);
    });

    this.searchBar.addEventListener("focus", (e) => {
      e.target.classList.remove("isBlurred");
    });
  }

  handleSearch(e) {
    e.preventDefault();
    const searchedItem = e.target.value;

    //Set Query Param:
    const url = new URL(window.location.href);
    this.suggestionsContainer.innerHTML = "";
    if (searchedItem != "") {
      url.searchParams.set("searchQuery", e.target.value);

      const relevantItems = this.searchItemsArray.filter((item) =>
        item.title.toLowerCase().includes(searchedItem.toLowerCase())
      );
      if (relevantItems && relevantItems.length > 0) {
        relevantItems.forEach((item) => {
          const itemContainer = document.createElement("a");
          itemContainer.classList.add("filteredItem");
          itemContainer.href = item.link;
          itemContainer.setAttribute("_target", "blank");
          itemContainer.innerText = item.title;
          this.suggestionsContainer.appendChild(itemContainer);
        });
      } else {
        this.suggestionsContainer.innerHTML =
          "<div class='noResults'>No brand matches the provided text.</div>";
      }
    } else {
      url.searchParams.delete("searchQuery");
    }
    window.history.pushState({}, "", url);
  }

  triggerFilter() {
    if (this.selectedLettersArray.length) {
      //Filter:
      const itemsToNotShow = Array.from(
        document.querySelectorAll("[data-starts-with]")
      ).filter((item) => {
        //reset:
        item.classList.remove("excluded");
        //Filter:
        return !this.selectedLettersArray.includes(
          item.getAttribute("data-starts-with")
        );
      });
      itemsToNotShow.forEach((item) => item.classList.add("excluded"));
    } else {
      document.querySelectorAll("[data-starts-with]").forEach((item) => {
        //reset:
        item.classList.remove("excluded");
      });
    }
  }

  checkQueryParams() {
    const url = new URL(window.location.href);
    const lettersToFilter = url.searchParams.get("selectedLetters");
    if (lettersToFilter && lettersToFilter.split(",").length)
      this.selectedLettersArray = lettersToFilter.split(",");

    const searchQuery = url.searchParams.get("searchQuery");
    if (searchQuery) {
      this.searchBar.value = searchQuery;
      this.searchBar.dispatchEvent(new Event("input"));
    }
  }

  selectButtonsOnLoad() {
    document.querySelectorAll(".brandLettersBtn").forEach((letterBtn) => {
      const isSelected = this.selectedLettersArray.find(
        (item) => item === letterBtn.innerText
      );
      if (isSelected) letterBtn.classList.add("filteredBrand");
    });
  }

  init() {
    this.getLetters();
    this.getAllBrands();
    this.setUpLettersButton();
    this.setUpSearchBar();
    this.checkQueryParams();
    this.selectButtonsOnLoad();
    this.triggerFilter();
  }
}
if (document.querySelector(".brandsNavigation")) {
  new brandsNavigationObject();
}

/*** Change Collection blurb when using filter to change collection **/
/*document.querySelector('.boost-pfs-filter-left-col')?.addEventListener('click', async e=>{
    if(e.target.closest('#boost-pfs-filter-tree2-pf-c-collection')){
        const link = e.target.closest('a.boost-pfs-filter-button');
        const collectionHandle = link.href;
        const response = await fetch(collectionHandle);
        const collectionText = await response.text();
        const collectionHTML = document.createElement('html');
        collectionHTML.innerHTML = collectionText;
        document.querySelector('[data-section-type="collection-header"]').innerHTML = collectionHTML.querySelector('[data-section-type="collection-header"]').innerHTML 
        if(collectionHTML.querySelector('.sub_collections li')){
            document.querySelector('.sub_collections').className = 'sub_collections'
            document.querySelector('.sub_collections').innerHTML = collectionHTML.querySelector('.sub_collections').innerHTML
            $('.sub_collections').slick({
              dots: false,
              arrows: true,
              infinite: true,
              speed: 300,
              slidesToShow: 5,
              slidesToScroll: 1,
              prevArrow:'<button type="button" class="slick-next pull-right"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 10L10 0L11.4 1.4L2.8 10L11.4 18.6L10 20L0 10Z" fill="#F2AE53"/></svg></button>',
              nextArrow:'<button type="button" class="slick-prev pull-left"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 10L1.99998 20L0.599976 18.6L9.19998 10L0.599976 1.4L1.99998 0L12 10Z" fill="#F2AE53"/></svg></button>',
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
              ]
          });
        }else{
          document.querySelector('.sub_collections').innerHTML = '';
        }

    }
})
*/
/*** Change Collection blurb when using filter to change collection End**/

/*** Collection Products Metafield Data***/
/*document.querySelector('.boost-pfs-filter-load-more-button')?.addEventListener('click', async e=>{
    const url = new URL(window.location.href);
    const newParams = new URLSearchParams([...url.searchParams.entries(), ["section_id","collection-products-metafields-boost"]]);
    const requestURL = `${url.origin}${url.pathname}?${newParams.toString()}`
    
    await initiateMetafieldsFetch(requestURL);
})



document.querySelector('.js-boost-pfs-filter-btn-load-previous-page')?.addEventListener('click', async e=>{
    const url = new URL(window.location.href);
    const newParams = new URLSearchParams([...url.searchParams.entries(), ["section_id","collection-products-metafields-boost"]]);
    window.productsWithMetafield=[];
    
    if(newParams.get('page')){
        const page = +newParams.get('page');
        //less than page because at the time it's clicked, the page param is not yet updated
        for(var i=1;i<page;i++){
            if(i===1){
                newParams.delete('page');
                const requestURL = `${url.origin}${url.pathname}?${newParams.toString()}`
                await initiateMetafieldsFetch(requestURL);
            }else{
                newParams.set('page', i);
                const requestURL = `${url.origin}${url.pathname}?${newParams.toString()}`
                await initiateMetafieldsFetch(requestURL);
            }
        }
    }
})


const initiateMetafieldsFetch = async (requestURL) =>{
    const response = await fetch(requestURL)
    const htmlText = await response.text();
    const parser = new DOMParser();
    const html = parser.parseFromString(htmlText, 'text/html')
    eval(html.querySelector('script').innerHTML);
}*/

/*** Collection Products Metafield Data End ***/

document.querySelectorAll(".cart-icon").forEach((i) =>
  i.addEventListener("click", (e) => {
    if (MinimogTheme?.Cart) {
      MinimogTheme.Cart.refreshCart();
    }
  })
);

const awaitMinimog = setInterval(() => {
  if (
    MinimogEvents &&
    MinimogEvents.events &&
    MinimogEvents.events.ON_CART_UPDATE
  ) {
    clearInterval(awaitMinimog);
    const disabledProductsRemover = () => {
      if (document.querySelector("[data-item-to-be-removed]")) {
        const key = document
          .querySelector("[data-item-to-be-removed]")
          .getAttribute("data-id");
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: `${key}`, quantity: 0 }),
        }).then(() => location.reload());
      }
    };
    disabledProductsRemover();
    MinimogEvents.events.ON_CART_UPDATE.push(disabledProductsRemover);
  }
}, 500);
